import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Business } from '../types';
type UseBusinessOptions = {
  slugName?: any;
};
export const getBusinessBySlug = ({ slugName }: UseBusinessOptions = {}): Promise<Business> => {
  return axios.get(`/business/slug/${slugName}`, {
    params: {},
  });
};

type QueryFnType = typeof getBusinessBySlug;
export const useBuisinessBySlug = ({ slugName }: UseBusinessOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['business-by-slug'],
    queryFn: () => getBusinessBySlug({ slugName }),
  });
};
